export const ERRORS = {
  NOT_FOUND: 'NOT_FOUND',
}

export const ERROR_MESSAGES = {
  FORBIDDEN: {
    title: 'Oops! Something went wrong.',
    description: [
      'Your request was blocked for security reasons.',
      'This might happen due to unexpected input or unusual activity.',
    ],
  },
} as Record<string, Alert>
